<div class="diagnostics-container">

  <div fxFlex fxLayout="column">
    <div class="title">
      DIAGNOSTICS DASHBOARD
    </div>

    <div *ngIf="isAdmin" fxLayoutAlign="space-around">
      <mat-form-field class="teacher-options" appearance="outline">
          <mat-label >Select Teacher</mat-label>
          <input  type="text" placeholder="Ex. John Doe" matInput [formControl]="teacherControl" [matAutocomplete]="teacher">
          <mat-autocomplete #teacher="matAutocomplete" (optionSelected)="teacherChanged($event.option.id)">
              <mat-option *ngFor="let teacher of filteredTeachers | async" [value]="teacher.FirstName+' '+teacher.LastName" [id]="teacher.UserID">
                  {{ teacher.FirstName }} {{ teacher.LastName }}
              </mat-option>
          </mat-autocomplete>
          <span mat-icon-button matSuffix (click)="clearTeacherValue()">
              <mat-icon class="clear-icon">{{ teacherControl.value?.length ? 'highlight_off': ''}}</mat-icon>
            </span>
      </mat-form-field>
    </div>

    <div *ngIf="isAdmin && !currentTeacherID" class="heading">
      Select a teacher to view their Class Diagnostic Data.
    </div>

    <div *ngIf="diagnosticsLoading" class="spinner-wrapper">
      <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
    </div>

    <div *ngIf="!diagnosticsLoading" class="panel-container">
      <mat-accordion [multi]="true" fxLayout="column" fxLayout.lt-md="column">
        <div *ngFor="let diagnostic of diagnosticsData">
          <app-class-panel 
          [diagnostics]="diagnostic"
          ></app-class-panel>
        </div>
      </mat-accordion>
    </div>

  </div>

</div>
